module.exports = __webpack_public_path__ + "media/images/social_preview-e68983459d5443e5198709e8d40f742e.jpg";